// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__155oA","clinicsSelect":"styles_clinicsSelect__pvIbj"};